import React, { Component } from "react";
import ChatBot from "react-simple-chatbot";
import { withRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import Api from '../../../utils/api';
import {
  chatContainerStyle,
  // chatContentStyle,
  chatbotContentStyleMobile,
  chatbotAvatarStyle,
  chatbotAvatarStyleMobile,
  chatbotBubbleStyle,
  chatbotFooterStyle,
  chatbotBubbleStyleMobile,
  helloAvaTheme
} from "../../utils/styles";
import * as util from "../../../utils/util";
import * as aaUtil from "../../utils/aaUtils";

import { ChatContainer } from "../../utils/styles";
import "../../../views/onboarding/Onboarding.css";

class AthOnboarding extends Component {
  constructor(props) {
    super(props);

    this.handleEnd = this.handleEnd.bind(this);

    this.state = {
      viewport: {
        width: document.documentElement.clientWidth,
        height: window.innerHeight
      },
      // startBoarding: localStorage.getItem("ath_user_id") ? false : true,
      startBoarding: false,
      chatbotStyle: {
        width: "100%",
        maxWidth: "1360px",
        //maxHeight: '100%',
        height: "100%",
        //height: (window.innerHeight * 0.925 - window.innerHeight * 2 * 0.032 - 20) + 'px', // 20 is the header logo height
        //height: this.state.viewport.height - 20,
        background: "#fff",
        overflow: "hidden",
        display: "none"
      },
      chatbotStyleMobile: {
        width: "100%",
        maxWidth: "996px",
        //maxHeight: '100%',
        height: "95%",
        //height: (window.innerHeight * 0.925 - window.innerHeight * 2 * 0.032 - 20) + 'px', // 20 is the header logo height
        //height: this.state.viewport.height - 20,
        background: "#fff",
        overflow: "hidden",
        overflowY: "scroll",
        display: "none"
      },
      handleEndSubmitState:true,
    };
  }

  fun_startBoarding = () => {
    aaUtil.event24_view_question("Intro/privacy question", "Consent Yes", "Q0");
    let chatbotStyleData = Object.assign({}, this.state.chatbotStyle, {
      display: "block"
    });
    let chatbotStyleMobileData = Object.assign(
      {},
      this.state.chatbotStyleMobileData,
      { display: "block" }
    );
    this.setState({
      startBoarding: false,
      chatbotStyle: chatbotStyleData,
      chatbotStyleMobile: chatbotStyleMobileData
    });
  };

  fun_endBoarding = () => {
    aaUtil.event24_view_question("Intro/privacy question", "Consent No", "Q0");
    setTimeout(() => {
      window.location.href = process.env.REACT_APP_UL_ATH_BUFFER_PAGE;
    }, 500);
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleMediaQueries.bind(this));
    this.fun_startBoarding();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleMediaQueries.bind(this));
  }

  handleMediaQueries() {
    this.setState({
      viewport: {
        width: document.documentElement.clientWidth,
        height: window.innerHeight
      }
    });
  }

  handleEnd({ steps }) {
    let buttonType = '';
    let requestBody = {};
    if(!steps){
      window.location.reload();
      return;
    }



    if (steps["Q0-1"]) {
      setTimeout(() => {
        window.location.href = process.env.REACT_APP_UL_ATH_BUFFER_PAGE;
      }, 500);
      return;
    }

    //Redirect to buffer page if user says No on quiz retake
    if (steps["Q2-1"]) {
      setTimeout(() => {
        this.props.history.push("/ath/profile");
      }, 500);
      return;
    }


    // The request may have a user id if user signin
    if (localStorage.getItem("ath_user_id")) {
      requestBody["userId"] = localStorage.getItem("ath_user_id");
    }

    const cookieId =  Api.getUUID();

    // The request may have user profile info if user has not signin
    if (!localStorage.getItem("ath_auth_token")) {
      requestBody["cookieId"] = cookieId;
      requestBody["Length"] = steps["A1"].value;
      requestBody["Shape"] = steps["A2"].value;
      requestBody["Texture"] = steps["A3"].value;
      requestBody["Scalp"] = steps["A4"].value;


      requestBody["Goals"] = steps["A5"].value[0];

      try {
        requestBody["Routines"] = steps["A6"].value[0];
      } catch (error) {}
      
      try {
        if(steps["A7"].value[0].indexOf('SKIP') == -1 ){
          requestBody["CurrentStyling1"] = steps["A7"].value[0];
        }
      } catch (error) {}

      try {
        if(steps["A8"].value[0].indexOf('SKIP') == -1 ){
          requestBody["CurrentStyling2"] = steps["A8"].value[0];
        }
      } catch (error) {}

      try {
        requestBody["Styling1"] = steps["A9"].value[0];
      } catch (error) {}
      
      requestBody["Styling2"] = steps["A10"].value;
      requestBody["gender"] = steps["A11"].value;

      util.setCookie("haCookieId",cookieId,10);

      
      try {
        requestBody["email"] = steps["A13"].value.split(":")[0];
        requestBody["firstName"] = steps["A13"].value.split(":")[1];
        requestBody["lastName"] = steps["A13"].value.split(":")[2];

        //日期格式：MM/DD/YYYY   2019/08/23
        let dateString = steps["A13"].value.split(":")[3]

        var birthDate = "";
        
        let dateArray = dateString.split("-")
        if(!!dateArray[0]){
          birthDate = `${dateArray[1]}/${dateArray[2]}/${dateArray[0]}`;
          if(!dateArray[2]){
            birthDate = dateString;
          }
        }else{
          birthDate = '';
        }
        try {
          dateString = dateString.replace(/undefined\//g,"");
        } catch (error) {
          dateString = "";
        }
        requestBody["birthDate"] = birthDate;

        requestBody["optIn"] = steps["A13"].value.split(":")[4];   // 输入账号信息中的选项
        requestBody[" "] = steps["A13"].value.split(":")[5];   // 输入账号信息中的选项

        buttonType = steps["A13"].value.split(":")[6];   // 提交按钮，点击的是submit or  skin
      } catch (error) {
        console.log('Account information cannot be empty')
      }
    }

    if (util.isMobile(navigator.userAgent)) {
      requestBody["signupSource"] = "mobile";
    }


    // Redirect to home if user says 'No' to region question.https://helloavadev.atlassian.net/browse/HD-357
    if (Object.keys(requestBody).length > 0 && this.state.handleEndSubmitState) {

      if(buttonType == "submitType"){
        aaUtil.event27_submit_quiz(true);
      }else if(buttonType == "skipType"){
        aaUtil.event2_click_event('SKIP');
    }

      fetch("/api/v1/ath/hair-profiles", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestBody)
      })
      .then((response) => {
        return response.text();
      }).then(result => {
          let href = window.location.href;
          let unileverArray =  href.split("?");
          let unileverParams = unileverArray[1] ? '&'+unileverArray[1] : ''

          if (process.env.REACT_APP_ENV === 'stage' || process.env.REACT_APP_ENV === 'dev') {
            window.location.href = `https://stage.allthingshair.com/en-us/hair-quiz/results?cid=${cookieId}${unileverParams}`;
          }else{
             window.location.href = `https://www.allthingshair.com/en-us/hair-quiz/results?cid=${cookieId}${unileverParams}`;
          }


          this.setState({
            handleEndSubmitState: false            
          })
        })
    }
  }

  render() {
    const chatbotStyle = {
      // width: "100%",
      // maxWidth: "1360px",
      // //maxHeight: '100%',
      // height: "100%",
      // //height: (window.innerHeight * 0.925 - window.innerHeight * 2 * 0.032 - 20) + 'px', // 20 is the header logo height
      // //height: this.state.viewport.height - 20,
      // background: "#fff",
      // overflow: "hidden"
    };

    // render() {
    let touchsupport =
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0;

    const chatContentStyle = {
      height: "100%",
      overflowX: "hidden",
      padding: "0",
      margin: "0"
      // marginTop: "10px"
    };

    const chatContentStyleMobile = {
      height: "100%",
      overflowX: "hidden",
      padding: "0",
      margin: "0"
      // marginTop: "10px"
    };

    return (
      <ChatContainer style={
        this.state.startBoarding
          ? { height: '99%' }
          : { height: '89%' }
      }>
          <ThemeProvider theme={helloAvaTheme}>
            <ChatBot
              className={!touchsupport ? "nontouch" : ""}
              hideHeader={true}
              hideUserAvatar={true}
              botAvatar="/images/onboarding/ava-chat.svg"
              steps={this.props.steps}
              handleEnd={this.handleEnd}
              // style={
              //   this.state.viewport.width <= 900
              //     ? this.state.chatbotStyleMobile
              //     : this.state.chatbotStyle
              // }
              style={chatbotStyle}
              contentStyle={
                this.state.viewport.width <= 900
                  ? chatContentStyleMobile
                  : chatContentStyle
              }
              avatarStyle={
                this.state.viewport.width <= 900
                  ? chatbotAvatarStyleMobile
                  : chatbotAvatarStyle
              }
              bubbleStyle={
                this.state.viewport.width <= 900
                  ? chatbotBubbleStyleMobile
                  : chatbotBubbleStyle
              }
              footerStyle={
                chatbotFooterStyle
              } /*enableSmoothScroll={ true } enableMobileAutoFocus={ true }*/
            />
          </ThemeProvider>
      </ChatContainer>
    );
  }
}

export default withRouter(AthOnboarding);



// WEBPACK FOOTER //
// ./src/ath/views/v1/AthOnboarding.js